import React from "react";

// Humanize an activity action code + optional value snapshot.
const LABELS = {
  "project.created": "Project created",
  "project.updated": "Project updated",
  "project.archived": "Project archived",
  "project.deleted": "Project deleted",
  "project.duplicated": "Project duplicated",
  "objective.set": "Objective set",
  "platforms.set": "Platforms updated",
  "kpi.created": "KPI added",
  "kpi.updated": "KPI updated",
  "kpi.deleted": "KPI removed",
  "budget.saved": "Budget saved",
  "budget.updated": "Budget updated",
  "timeline.saved": "Timeline saved",
  "context.saved": "Business context saved",
  "strategy.generated": "AI strategy generated",
  "strategy.regenerated": "AI strategy regenerated",
  "strategy.edited": "Strategy edited",
  "strategy.approved": "Strategy approved",
  "strategy.rejected": "Strategy rejected",
  "strategy.restored": "Strategy version restored",
  "note.created": "Note added",
  "note.updated": "Note updated",
  "note.deleted": "Note deleted",
  "file.uploaded": "File uploaded",
  "file.deleted": "File deleted",
};

export default function ActivityFeed({ items }) {
  if (!items || items.length === 0) {
    return <p className="proj-muted">No activity yet.</p>;
  }
  return (
    <ul className="activity-feed">
      {items.map((a) => (
        <li key={a.id}>
          <span className="activity-dot" />
          <span className="activity-label">{LABELS[a.action] || a.action}</span>
          <span className="proj-sub">{new Date(a.createdAt).toLocaleString()}</span>
        </li>
      ))}
    </ul>
  );
}
